<template>
  <!-- -FORM PANEL- -->
  <div ref="tagform" class="col s12 m12 l4 xl3" id="infoPanel">
    <div  v-if="showTagForm && tag!= null" class="panel ltgrey padded40" id="newSpecies" style="display: block;">
      <span @click="closeTagForm" class="ion-close closeButton"></span>
      <h3 v-if="tagId <= 0">Add New Tag</h3>
      <h3 v-if="tagId > 0">Update Tag</h3>
      <div class="duplicateForm" v-if="showDuplicateForm && !disableDuplicateForm">
        <div>
          <label>Duplicate Tag</label>
          <select ref="duplicatedSppInput" class="initialized" v-model="duplicateSppId" type="number">
            <option v-for="(option, index) in speciesIndividuals" :key="'duplicatspp' +index" :value="option.id">{{option.species.code}} | {{option.uniqueName}}</option>
          </select>
          <span class="invalid_msg">{{duplicateFormError}}</span>
        </div>
        <div>
          <label>Vocalization (if differs from the first)</label>
          <select class="initialized" v-model="inputVocalizationId" type="number">
            <option disabled="" selected="">Choose Type</option>
            <template v-for="(option, index) in options.vocalization">
              <option :key="'vol' +index" :value="option.id"
                v-if="!option.deprecated"  >
                {{option.type}}</option>
            </template>
          </select>
        </div>
        <div class="row">
          <div class="col s6 m6 l12 xl6">
            <input type="button" v-if="isEditable" @click="duplicateTag" id="btnLock" class="btn btn-success fullWidth" value="Duplicate">
          </div>
          <div class="col s6 m6 l12 xl6">
            <input type="button" v-if="isEditable" @click="switchToNewForm" id="btnLock" class="btn btn-action fullWidth" value="New">
          </div>
        </div>
      </div> <!-- duplicate form-->

      <div class="newForm autofilterInput" v-show="!showDuplicateForm || disableDuplicateForm">
        <div>
          <div v-if="!editParent || !isEditable">{{tag.speciesIndividualTagCount}} tagged on this individual </div>
          <label for="autocomplete-input" class="active">Species</label>
          <span class="displayValue" v-if="!editParent || !isEditable">: {{tag.speciesIndividual.species.code}} | {{tag.speciesIndividual.species.englishName}}</span>
          <!-- {{!this.tag.speciesIndividual.species.inAlberta?'(Out of Alberta)':''}} -->
          <auto-complete v-show="editParent && isEditable" ref="speciesInput"
            placeholder="Species (use space to list all names)"
            :source= "getSpeciesAPIUrl"
            initialValue=""
            initialDisplay=""
            name="code"
            resultsValue="code"
            :results-display="formattedSpeciesDisplay"
            clearButtonIcon="ion-close"
            excludeCharacter ='|'
            :request-headers="authHeaders"
            :custom-result="autoIdSpecies"
            @selected="setSpeciesId"
            @clear="clearSpeciesInput"
            @focus="appendAutoSpeciesIds"
          >
          </auto-complete>
          <span class="invalid_msg" v-if="editParent && invalidSpecies">Please enter a valid species name, use UNKN if it is unknown </span>
        </div>

        <div>
          <label>Individual (Optional)<span  class="ion-information-circled" v-tooltip="'System will autogenerate this number if left empty'"></span></label>
          <span class="displayValue" v-if="!editParent || !isEditable">: {{tag.speciesIndividual.uniqueName}}</span>
          <input v-if="editParent && isEditable" type="number" placeholder="Individual *Auto Generated*" step="1" min="0" max="100" v-model.number="tag.speciesIndividual.uniqueName"
            @input="loadSppIndividualInfo" >
            <span class="invalid_msg" v-if="editParent && tagId && existingIndividual">Caution: This Individual already exists. If it is in the same minute, you will get a error.</span>
            <span class="invalid_msg" v-if="editParent && !tagId && existingIndividual">This Individual already exists. Updating it will update all records</span>
        </div>

        <div>
          <label>Confidence</label>
          <template v-if="!editParent || !isEditable">
            <span v-for="(option, index) in options.confidence" :key="'confident' + index">
              <span class="displayValue" v-if="option.id === tag.speciesIndividual.confidenceId">{{option.type}}</span>
            </span>
          </template>
          <template v-else>
            <select class="initialized" v-model="tag.speciesIndividual.confidenceId" type="number">
              <!--<option disabled="" selected="">Choose </option> -->
              <option v-for="(option, index) in options.confidence" :key="'confidentSel' + index" :value="option.id">{{option.type}}</option>
            </select>
          </template>
        </div>

        <div>
          <label>Abundance <span  class="ion-information-circled" v-tooltip="'1 or 2 for birds; 3-5 for amphibians'"></span></label>
          <template  v-if="!editParent || !isEditable">
            <span v-for="(option, index) in options.abundance" :key="'abund' +index">
              <span class="displayValue" v-if="option.id === tag.speciesIndividual.abundanceId">{{option.type}}</span>
            </span>
          </template>
          <template v-else>
            <select class="initialized" v-model="tag.speciesIndividual.abundanceId" type="number">
              <!--<option disabled="" selected="">Choose </option> -->
              <option v-for="(option, index) in options.abundance" :key="'abundanceSel' +index" :value="option.id">{{option.type}}</option>
            </select>
          </template>
        </div>
        <div v-if="!editParentOnly">
          <label>Vocalization</label>
          <template v-if="!isEditable">
            <span v-for="(option, index) in options.vocalization" :key="'vocal' + index">
              <span class="displayValue" v-if="option.id === tag.vocalizationId">{{option.type}}</span>
            </span>
          </template>
          <template v-else>
            <select v-if="isEditable" class="initialized" v-model="tag.vocalizationId" type="number">
              <!--<option disabled="" selected="">Choose Type</option> -->
              <template v-for="(option, index) in options.vocalization" >
                <option :key="'vocalSel' + index" :value="option.id"
                v-if="!option.deprecated || isVocalizationDeprecated"  :disabled="option.deprecated">{{option.type}}</option>
              </template>
            </select>
          </template>
          <span class="invalid_msg" v-if="formIncomplete">{{this.incompleteTagMsg}}</span>
        </div>
        <div>
          <label>Comments </label>
          <span v-if="!editParent || !isEditable" class="displayValue">{{tag.speciesIndividual.comments}}</span>
          <textarea v-if="editParent && isEditable" v-model="tag.speciesIndividual.comments"></textarea>
        </div>
        <hr class="divider"/>
        <div class="row">
          <div class="col s6 m6 l12 xl4">
            <input v-if="isEditable" type="button" @click="insertUpdateTag" class="btn btn-action fullWidth" value="Save">
          </div>
          <div class="col s4" v-if="tagId > 0">
            <input v-if="isEditable" type="button" @click="removeTag()"  class="btn btn-outline fullWidth" value="Delete">
          </div>

          <div class="col s4">
            <input type="button" v-if="tagId <= 0 && isEditable && speciesIndividuals.length > 0 && !disableDuplicateForm" @click="showDuplicateForm=true" id="btnLock" class="btn btn-action fullWidth" value="Duplicate">
          </div>
          <div class="col s6 m6 l12 xl4">
            <input type="button"  @click="closeTagForm(false)" class="btn btn-border fullWidth" value="Cancel">
          </div>
          <div class="col s4" v-if="tag.speciesIndividualTagCount > 1">
            <input type="button" v-if="!editParent && isEditable " @click="editParent=true" id="btnLock" class="btn btn-action fullWidth" value="Edit All Fields">
            <input type="button" v-if="editParent && isEditable" @click="editParent=false" id="btnLock" class="btn btn-action fullWidth" value="Edit Current Fields">
          </div>
        </div>
      </div>
    </div> <!-- tag form -->

    <div class="panel ltgrey padded40">
      <span @click="toggleTaskForm(false)" class="ion-close closeButton"></span>
      <h3>Task Info</h3>
      <!-- <div class="row" v-if="taskOverview.isUserAdmin && isEditable">
        <div  class="col s6 m6 l12 xl6" >
          <a @click="switchTaskLock(true)" id="btnLock" class="btn btn-action fullWidth"> Lock</a>
        </div>
        <div  class="col s6 m6 l12 xl6" >
          <a @click="switchTaskLock(false)" id="btnLock" class="btn btn-action fullWidth"> UnLock</a>
        </div>
        -<div class="col s6 m6 l12 xl6" >
          <a id="btnDel" class="btn btn-border fullWidth"> Delete</a>
        </div>
      </div>
      -->
      <!-- <div class="row margin0">
        <div class="col s6">
          <div>
            <label>Combo </label>
              <input type="number" step="1" min="0" max="100" placeholder="Combo" v-model="task.combinationQty" >
            </div>
        </div>
        <div class="col s6">
          <div>
            <label>Volume </label>
            <input v-model="task.volumeQty" type="number" step="1" min="0" max="12" placeholder="1-12" :class="{'invalid': (task.volumeQty > 12 || task.volumeQty< 0)}" >
          </div>
        </div>
      </div> -->
      <div>
        <label>Rain </label>
          <select :disabled="!taskOverview.canUserModify ||(!taskOverview.isUserAdmin && !taskOverview.isUserTranscriber)" class="initialized" v-model="task.rainId" type="number">
          <option value="-100" disabled selected>Level</option>
          <option v-for="(option, index) in options.rain" :key="'rainSel' + index" :value="option.id">{{option.type}}</option>
        </select>
      </div>
      <div>
        <label>Wind </label>
        <select :disabled="!taskOverview.canUserModify ||(!taskOverview.isUserAdmin && !taskOverview.isUserTranscriber)" class="initialized" v-model="task.windId" type="number">
          <option value="-100" disabled selected>Level</option>
          <option v-for="(option, index) in options.wind" :key="'windSel' + index" :value="option.id">{{option.type}}</option>
        </select>
      </div>

      <div>
        <label>Industry </label>
            <select :disabled="!taskOverview.canUserModify ||(!taskOverview.isUserAdmin && !taskOverview.isUserTranscriber)" class="initialized" v-model="task.industrialNoiseId" type="number">
          <option value="-100" disabled selected>Level</option>
          <option v-for="(option, index) in options.industrialNoise" :key="index" :value="option.id">{{option.type}}</option>
        </select>
      </div>

      <div>
        <label>Noise </label>
            <select :disabled="!taskOverview.canUserModify ||(!taskOverview.isUserAdmin && !taskOverview.isUserTranscriber)" class="initialized" v-model="task.otherNoiseId" type="number">
          <option value="-100" disabled selected>Level</option>
          <option v-for="(option, index) in options.noise" :key="index" :value="option.id">{{option.type}}</option>
        </select>
      </div>

      <div>
        <label>Audio Quality </label>
          <select :disabled="!taskOverview.canUserModify ||(!taskOverview.isUserAdmin && !taskOverview.isUserTranscriber)" class="initialized" v-model="task.audioQualityId" type="number">
          <option value="-100" disabled selected>Are there Issues?</option>
          <option v-for="(option, index) in options.audioQuality" :key="index" :value="option.id">{{option.type}}</option>
        </select>
      </div>

      <div>
        <label>Comments </label>
        <textarea :disabled="!taskOverview.canUserModify ||(!taskOverview.isUserAdmin && !taskOverview.isUserTranscriber)" v-model="task.comments"></textarea>
        <span class="invalid_msg">{{taskValidateMessage}}</span>
        <span class="invalid_msg">{{taskUpdateMessage}}</span>
      </div>
      <div class="row">
        <div class="col s6">
          <input v-if="taskOverview.canUserModify && (taskOverview.isUserAdmin || taskOverview.isUserTranscriber)"  @click="updateTask" id="btnSubmit" type="submit" value="Update" class="btn btn-success fullWidth">
        </div>
        <div class="col s6">
          <input type="button" @click="toggleTaskForm(false)" class="btn btn-border fullWidth" value="Close">
        </div>
      </div>
    </div>
  </div>
<!-- -END FORM PANEL- -->
</template>

<script>
import Vue from 'vue'
// import Autocomplete from '@/components/utils/vue-autocomplete'
import Autocomplete from 'vuejs-auto-complete';
import {getAuthorizaitonHeader, API_URL} from '@/lib/common';
import { eventBus } from '@/lib/eventbus';
import { VTooltip } from 'v-tooltip';

Vue.directive('tooltip', VTooltip)

export default {
  name: 'recording-form',
  props: ['showTagForm', 'taskOverview', 'tagId', 'task', 'drawBox', 'options', 'isEditable', 'toScroll', 'editParentOnly', 'taskUpdateMessage'],
  components: {'auto-complete': Autocomplete},
  data () {
    return {
      incompleteTagMsg: 'The Add Tag form is incomplete, please ensure all fields are complete and values are within acceptable ranges.',
      deleteTagMsg: 'You are about to delete this record, are you sure?',
      taskValidateMessage: '',
      formIncomplete: false,
      getTagDetailUrl: API_URL + 'get-tag-details',
      // updateTagUrl: API_URL + 'insert-update-tag-details',
      getSpeciesAPIUrl: API_URL + 'get-species?filter=',
      getSpeciesIndividualUrl: API_URL + 'get-species-individual-list-by-task',
      getSpeciesDetailsByIndividualUrl: API_URL + 'get-species-individual-by-code-uniquename',
      tag: {
        speciesIndividual: {
          species: {}
        }
      },
      invalidSpecies: false,
      existingIndividual: false,
      showDuplicateForm: false,
      disableDuplicateForm: false,
      duplicateSppId: -1,
      editParent: true,
      speciesIndividuals: [],
      duplicateFormError: '',
      inputVocalizationId: null,
      orgTag: null,
      autoIdSpecies: [],
      isVocalizationDeprecated: false
    }
  },
  mounted () {
    this.loadTag();
    // if speciesPerTask = 1 OR (speciesPerMinute = 1 AND minLength = 1)
    this.disableDuplicateForm = this.taskOverview.method.speciesPerTaskLimit === 1 || (this.taskOverview.method.speciesPerMinuteLimit === 1 && this.taskOverview.method.minLength === 1);
  },
  watch: {
    tagId: function (newVal, oldVal) {
      if (this.tagId !== null) {
        this.loadTag();
      }
    },
    showDuplicateForm: function (newVal, oldVal) {
      this.autoFocus();
    },
    showTagForm: function (newVal, oldVal) {
      this.autoFocus();
    },
    drawBox: function (newVal, oldVal) {
      this.autoIdSpecies = [];
    }
  },
  computed: {
    /* attache headers for auto complete input */
    authHeaders () {
      const header = getAuthorizaitonHeader();
      return { 'Authorization': header };
    }
  },
  methods: {
    autoFocus: function () {
      let that = this;
      this.$nextTick(() => {
        if (that.showTagForm) {
          that.$refs.duplicatedSppInput && that.$refs.duplicatedSppInput.focus();
          try {
            that.$refs.speciesInput && that.$refs.speciesInput.$el.querySelector('input').focus();
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
    scrollTop: function () {
      window.scrollTo(0, this.$refs.tagform.offsetTop * 2);
    },
    async loadTag () {
      const self = this;
      this.editParent = true;
      if (this.tagId > 0) { // get current from database if id is provided.
        /* get tag form details */
        this.$http.get(this.getTagDetailUrl, {params: { tagId: this.tagId }}).then(function (response) {
          if (!response.data.hasOwnProperty.call('error')) {
            this.tag = response.data;
            this.orgTag = {};
            try {
              this.orgTag.uniqueName = this.tag.speciesIndividual.uniqueName;
              this.orgTag.sppCode = this.tag.speciesIndividual.species.code;
            } catch (e) {}

            const speciesDisplay = this.tag.speciesIndividual.species.code + ' | ' + this.tag.speciesIndividual.species.englishName;
            if (this.$refs.speciesInput) {
              this.$refs.speciesInput.display = speciesDisplay;
            }
            if (this.tag.speciesIndividualTagCount > 1) {
              this.editParent = false;
            }
            /* check if vocalization type is deprecated */
            this.isVocalizationDeprecated = this.options.vocalization.findIndex(function (element) {
              return element.deprecated === true && element.id === self.tag.vocalizationId;
            }) >= 0;
          }
        });
        // check if there are other existing species, so in case users want to update sppCode, and unique name we can check them.
        this.$http.get(this.getSpeciesIndividualUrl, {params: {taskId: this.task.id}}).then(function (response) {
          if (!response.data.hasOwnProperty.call('error')) {
            this.speciesIndividuals = response.data;
          }
        });
        this.showDuplicateForm = false;
      } else { // it is a new tag to be inserted
        // for new tag box, send API to get AutoTag results
        const params = {
          params: {
            taskId: this.taskOverview.taskId,
            startX: Math.floor(this.drawBox.boxStartX),
            startY: Math.floor(this.drawBox.boxStartY),
            width: Math.floor(this.drawBox.boxWidth),
            height: Math.floor(this.drawBox.boxHeight)
          }
        };
        const that = this;
        this.$http.get(API_URL + 'get-species-predictions', params).then(function (response) {
          if (!response.body.hasOwnProperty.call('error')) {
            that.autoIdSpecies = response.body;
          }
        });

        // check if there are other existing species, if so hide the duplicated form
        await this.$http.get(this.getSpeciesIndividualUrl, {params: {taskId: this.task.id}}).then(function (response) {
          if (!response.data.hasOwnProperty.call('error')) {
            this.speciesIndividuals = response.data;
            if (this.speciesIndividuals.length === 0) {
              // console.log('no previous spp exists');
              this.showDuplicateForm = false;
            } else {
              this.showDuplicateForm = true;
            }
          }
        });

        if (this.showDuplicateForm) {
          /* duplciated form only enter spp and behavior, dont't pass the rest values
            as they are the same spp,
          */
          this.tag = {
            speciesIndividual: {
              abundanceId: null,
              confidenceId: null,
              species: {}
            }
          };
        } else {
          /* set default tag values for full form enter
            CONFIDENCE 0 | Confident
            ABUNDANCE 1 | ONE
          */
          this.tag = {
            vocalizationId: 1,
            speciesIndividual: {
              abundanceId: 1,
              confidenceId: 0,
              species: {}
            }
          };
        }

        this.orgTag = this.tag;
        this.tag.isMarker = false;
        if (this.$refs.speciesInput) {
          this.$refs.speciesInput.display = '';
        }
      }
      this.tag.taskId = this.task.id;
      const that = this;
      Object.keys(that.drawBox).forEach(function (key) { if (key.startsWith('box')) { that.tag[key] = Math.floor(that.drawBox[key]); } });

      this.invalidSpecies = false;

      if (this.toScroll) {
        this.scrollTop();
      }
    },
    switchToNewForm () {
      this.showDuplicateForm = false;
      this.tag.speciesIndividual.species = {}
      //show defaults in form
      this.tag.vocalizationId = 1;
      this.tag.speciesIndividual.abundanceId = 1;
      this.tag.speciesIndividual.confidenceId = 0;
    },
    insertUpdateTag () { // insert a tag, do validatation
      this.formIncomplete = false;
      if (this.tag.speciesIndividual.species.code == null) {
        this.invalidSpecies = true;
        return;
      }

      if (typeof this.tag.vocalizationId === 'undefined' || this.tag.speciesIndividual.abundanceId == null || this.tag.speciesIndividual.confidenceId == null) {
        this.formIncomplete = true;
        return;
      }

      const newTag = {...this.tag};
      newTag.hasAIResult = (this.autoIdSpecies.length > 0);
      eventBus.$emit('update-tag', newTag); // update tag details
    },
    removeTag () { // remove tag and hide tag form
      if (this.tagId > 0) {
        if (!confirm(this.deleteTagMsg)) {
          return;
        }
        eventBus.$emit('delete-tag', this.tagId);
      }
      this.closeTagForm();
    },

    duplicateTag () {
      // duplicates have abundance and confidence as null and no vocId
      this.tag.vocalizationId = null;
      this.tag.speciesIndividual.abundanceId = null;
      this.tag.speciesIndividual.confidenceId = null;

      this.duplicateFormError = '';
      if (!this.duplicateSppId || this.duplicateSppId < 0) {
        this.duplicateFormError = 'Missing duplicated species information';
        return;
      }
      this.tag.speciesIndividual.id = this.duplicateSppId;
      if (this.inputVocalizationId && this.inputVocalizationId > 0) {
        this.tag.vocalizationId = this.inputVocalizationId;
      }
      eventBus.$emit('update-tag', this.tag);//eventBus.$emit('update-basic-tag', this.tag);
    },
    closeTagForm () {
      eventBus.$emit('show-tag-form', false);
    },
    toggleTaskForm (show) {
      eventBus.$emit('toggle-form', show);
    },
    updateTask () {
      this.taskValidateMessage = '';
      if (this.task.otherNoiseId == null ||
          this.task.industrialNoiseId == null ||
          this.task.windId == null ||
          this.task.rainId == null ||
          this.task.audioQualityId == null) {
        this.taskValidateMessage = 'All fields are required except comments';
        return;
      }
      eventBus.$emit('update-task');
    },
    hideTaskForm () {
      eventBus.$emit('toggle-form', false);
    },
    formattedSpeciesDisplay (result) {
      return result.code + ' | ' + result.englishName + ' | ' + (result.prediction ? ' ' + Math.floor(result.prediction * 100) + '%' : '');
    },
    appendAutoSpeciesIds (response) {
      return response;
    },
    setSpeciesId (speciesRow) {
      if (speciesRow.selectedObject) {
        this.tag.speciesIndividual.species = speciesRow.selectedObject;
      } else {
        this.tag.speciesIndividual.species = speciesRow;
      }
      // console.log(this.tag.speciesIndividual.species);
      this.invalidSpecies = false;
      if (this.tag.uniqueName != null) {
        this.loadSppIndividualInfo();
      }
    },
    clearSpeciesInput () {
      this.tag.speciesIndividual.species = {};
    },
    /**
     * using spp code and unique number combination to check if same individual already exists in DB,
     * if yes, so invalid msg.
     */
    loadSppIndividualInfo () {
      this.existingIndividual = false;
      // when there is no species individuals don't call api
      if (this.speciesIndividuals.length === 0) {
        return;
      }
      const code = this.tag.speciesIndividual.species.code;
      const uniqueName = this.tag.speciesIndividual.uniqueName;
      if (code !== null && code !== '' && uniqueName != null && uniqueName !== '') {
        // search for this code combination in the speciesIndividual list
        for (let i = 0; i < this.speciesIndividuals.length; i++) {
          if (this.speciesIndividuals[i].uniqueName === uniqueName &&
          this.speciesIndividuals[i].species.code === code) {
            // for new tag, load tag information
            if (!this.tagId) { // new tag
              this.$http.get(this.getSpeciesDetailsByIndividualUrl, {params: {taskId: this.task.id, code: code, uniqueName: uniqueName}}).then(function (response) {
                if (!response.data.hasOwnProperty.call('error')) {
                  const data = response.data;
                  this.existingIndividual = true;
                  this.tag.speciesIndividual.abundanceId = data.abundanceId;
                  this.tag.speciesIndividual.confidenceId = data.confidenceId;
                  this.tag.speciesIndividual.comments = data.comments;
                }
              });
            } else { // existing tag
              if (this.orgTag.uniqueName !== uniqueName ||
                this.orgTag.sppCode !== code) {
                this.existingIndividual = true;
              }
            }
            return;
          }
        }
      }
    }
  }
}
</script>
<style>
.closeButton {
  float: right;
}
.btn.btn-action {
  background-color: #C94412;
  border: 1px solid #ad3a0f;
  color: #fff;
}
.btn.btn-outline {
  border: 1px solid #9e9e9e;
  background-color: #C94412;
}

.displayValue {
  color:#f1516d;
}

.btn:focus {
  border: 2px solid #cccccc;
}
hr.divider {
  margin:10px 0;
}
.margin0 {
  margin: 0;
}

li.autocomplete__results__item.customResult {
    background-color: #e4ab47;
    border-bottom: 1px dotted #867862;
}
select option[disabled] { color: #ccc; }

textarea:disabled{
  resize:none;
}

/* .autocomplete__inputs input:focus{
  background-color: #dee7ee;
} */
</style>
